import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import pharmaXPSImage from "../../../../assets/imgs/services/nationals/pharma-xps.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import "./pharma-xps.css";
import NationalDescription from "../../../../components/national-description/national-description";
import cajasImage from "../../../../assets/imgs/services/nationals/pharma-xps/cajas.png";
import courier1Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier1.svg";
import courier2Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier2.svg";
import courier4Icon from "../../../../assets/imgs/services/nationals/courier-icons/courier4.svg";
import hightech1Icon from "../../../../assets/imgs/services/nationals/hightech-icons/hightech1.svg";
import humanremains1Icon from "../../../../assets/imgs/services/nationals/humanremains-icons/humanremains1.svg";
import condiciones02Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg";

function PharmaXPS() {
  const [tPharmaXPS] = useTranslation("pharmaXpsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idPharmaXPS = "baded5a0-8456-4843-bdde-8e3e3abb27a9";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);
  const nonApplicableIcons = [
    humanremains1Icon,
    courier2Icon,
    courier4Icon,
  ];
  const additionalConditionIcons = [
    hightech1Icon,
    courier1Icon,
    condiciones02Icon,
  ];

  const getListItems = (translationPath) => {
    const list = tPharmaXPS(`${translationPath}.items`, { returnObjects: true });

    if (Array.isArray(list) && list.length > 0) {
      return list;
    }

    const legacyItems = [1, 2, 3]
      .map((index) => tPharmaXPS(`${translationPath}.item${index}`))
      .filter((item) => item && !item.includes(`${translationPath}.item`));

    return legacyItems;
  };

  const nonApplicableCharges = getListItems("non-applicable-charges");
  const additionalConditions = getListItems("additional-conditions");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[8]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[8]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idPharmaXPS}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            JSON.stringify({
              ops: [
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Estaciones con cámara fría: Culiacán (CUL), Cancún (CUN), Guadalajara (GDL), Hermosillo (HMO), Ciudad de México (MEX), Mérida (MID), Monterrey (MTY), Puerto Vallarta (PVR), San José del Cabo (SJD), Tijuana (TIJ), Villahermosa (VSA).",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Estaciones internacionales con cámara fría: Nueva York (JFK), Chicago (ORD), Miami (MIA), Los Ángeles (LAX), Toronto (YYZ), Madrid (MAD), Londres (LHR), Paris (CDG), Ámsterdam (AMS), Narita (NRT), Seúl (ICN), San José Costa Rica (SJO), Guatemala (GUA), Santiago de Chile (SCL), Lima (LIM), Buenos Aires (EZE), Quito (UIO) y Guarulhos (GRU).",
                },
                { attributes: { list: "bullet" }, insert: "\n" },
                {
                  attributes: { color: "#888888" },
                  insert:
                    "Es obligatorio declarar la descripción exacta del producto, en caso de aerosoles o líquidos, entregar la hoja de seguridad del producto (MSDS) a personal de mostrador para la validación del envío. No serán aceptadas descripciones genéricas.",
                },
              ],
            })
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us[
              "03-Documentation, Acceptance and Delivery"
            ].content
          );
          setAccordion3(response.data.textWeb.text_us["04-Packaging and Special Handling"]?.content || "");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const renderInfoItems = (items, icons) => {
    if (!Array.isArray(items)) return null;

    return items.map((item, index) => (
      <div className="item" key={`${item}-${index}`}>
        <div className="icon">
          <img src={icons[index % icons.length]} alt="" aria-hidden="true" />
        </div>
        <p>{item}</p>
      </div>
    ));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("pharmaXPS.title")}</title>
        <meta
          name="description"
          content={tSMetaData("pharmaXPS.description")}
        />
      </Helmet>
      <ImageHeader imgBackground={pharmaXPSImage} />

      <div className="info-national-content">
        <NationalDescription
          title={tPharmaXPS("header.title")}
          description={textDescription ? JSON.parse(textDescription) : ""}
          quoteBtn={tPharmaXPS("header.quote-btn")}
          quoteProductID="btnQuoteXPS"
          contactSales={tPharmaXPS("header.contact-sales")}
          contactProductID="btnContactXPS"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tPharmaXPS("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tPharmaXPS("accordion-1.title")}
              content={accordion1 ? JSON.parse(accordion1) : "{}"}
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tPharmaXPS("accordion-2.title")}
              content={accordion2 ? JSON.parse(accordion2) : "{}"}
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tPharmaXPS("accordion-3.title")}
              content={accordion3 ? JSON.parse(accordion3) : {}}
            />

            {openAccordion === 3 && (
              <div className="xps-packaging-status">
                <h5>Estado de su embalaje</h5>
                <p>
                  Todo embalaje debe proporcionar protección adecuada de su contenido.
                  Es decir, el tamaño del embalaje debe ser proporcional a las
                  dimensiones del producto, debe prevenir la contaminación de otro
                  producto o fugas o filtraciones.
                </p>
                <img src={cajasImage} alt="Estado de embalaje Pharma XPS" />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="more-info-content pharma-xps-more-info">
        <div className="more-info-box">
          <h5>{tPharmaXPS("non-applicable-charges.title")}</h5>

          <div className="icons">{renderInfoItems(nonApplicableCharges, nonApplicableIcons)}</div>
        </div>

        <div className="more-info-box">
          <h5>{tPharmaXPS("additional-conditions.title")}</h5>

          <div className="icons">
            {renderInfoItems(additionalConditions, additionalConditionIcons)}
          </div>
        </div>
      </div>
    </>
  );
}

export default PharmaXPS;
